import request from "@/utils/request.js"
// 获取社会招聘配置页面
export function get_society_config(data){
  return request({
    	  method:'GET',
    	  url:'/recruit/society_config',
    	  params:data
    })
}
// 校园招聘配置页面
export function get_campus_config(data){
  return request({
    	  method:'GET',
    	  url:'/recruit/campus_config',
    	  params:data
    })
}
// 招聘列表 参数：type(1社会 2校园招聘 - 实习生 3校园招聘 - 应届生), keywords, function_type, city_id
export function get_recruit_list(data){
  return request({
    	  method:'POST',
    	  url:'/recruit/recruit_list',
    	  data:data
    })
}
// 最新职位
export function get_new_position(data){
  return request({
    	  method:'GET',
    	  url:'/recruit/get_new_position',
    	  params:data
    })
}
// 职能类型 列表 参数：type(1社会 2校园招聘 - 实习生 3校园招聘 - 应届生),
export function get_function_type(data){
  return request({
    	  method:'GET',
    	  url:'/recruit/get_function_type',
    	  params:data
    })
}
 // 获取城市 列表 参数：type(1社会 2校园招聘 - 实习生 3校园招聘 - 应届生),
 export function get_city(data){
   return request({
     	  method:'GET',
     	  url:'/recruit/get_city',
     	  params:data
     })
 }
 //  岗位详情，参数：id
 export function recruit_read(data){
   return request({
     	  method:'GET',
     	  url:'/recruit/recruit_read',
     	  params:data
     })
 }
 //  获取手机号区号
 export function get_phone_area_code(data){
   return request({
     	  method:'GET',
     	  url:'/recruit/get_phone_area_code',
     	  params:data
     })
 }
 //  获取简历投递 social_positions_id，curriculum_vitae，annex，username，suffix，phone，email
 export function resume_submission(data){
   return request({
     	  method:'POST',
     	  url:'/recruit/resume_submission',
     	  data:data
     })
 }
 